import { DateRage } from "components/HeroSearchForm/type";

const converSelectedDateToString = ([startDate, endDate]: DateRage) => {
  const formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('es-AR', { month: 'short' });
    return `${day} ${month}`;
  };

  const dateString =
    (startDate ? formatDate(startDate) : "") +
    (endDate ? " - " + formatDate(endDate) : "");

  return dateString;
};

export default converSelectedDateToString;